import React from 'react'
import PropTypes from 'prop-types'
import clsx from 'clsx'
import { Button as MuiButton, styled } from '@mui/material'

const themes = {
    primary: {
        background: '#453fbb',
        highlight: '#453fbb',
        color: '#fff',
    },
    danger: {
        background: '#ff5e65',
        highlight: '#ff5e65',
        color: '#fff',
    },
}

const StyledButton = styled(MuiButton)(({ themeColor }) => ({
    '& svg:first-child': {
        marginRight: 10,
    },
    borderRadius: '5px',
    backgroundColor: themes[themeColor].background,
    '&:hover': {
        backgroundColor: themes[themeColor].highlight,
    },
    color: themes[themeColor].color,
}))

const Loader = styled('div')({
    marginRight: 10,
})

const Button = ({
    loading,
    icon,
    size,
    children,
    className,
    themeColor,
    ...rest
}) => {
    return (
        <StyledButton
            size={size}
            disabled={loading}
            {...rest}
            className={clsx(className)}
            themeColor={themeColor}
        >
            {loading && <Loader />}
            {!loading && icon}
            {children}
        </StyledButton>
    )
}

Button.propTypes = {
    ...MuiButton.propTypes,
    loading: PropTypes.bool.isRequired,
    icon: PropTypes.any,
    themeColor: PropTypes.string,
}

Button.defaultProps = {
    ...MuiButton.defaultProps,
    loading: false,
    size: 'medium',
}

export default Button
export { default as Fab } from './Fab'
export { default as ExtendedFab } from './ExtendedFab'
